export type { ScoreProps } from "./Score";
export { default, Score } from "./Score";
